import React, {useEffect, useState} from 'react';
import './style.css'
import {MyTestItems} from "./my-test-items/my-test-items";
import {TestRowThead} from "./test-row-thead/test-row-thead";
import {MyTestSearch} from "./my-test-search/My-test-search";
import {useAppDispatch, useAppSelector} from "common/hook";
import {NothingYetMessage} from "../../../../personal-cabinet/nothing-yet-message/NothingYetMessage";
import {Preloader} from "components/layout/preloader/Preloader";
import {useSearchInputChangeHandler} from "common/hook/searchUtils";
import {CustomPagination} from "components/pagination/CustomPagination";
import {getTests} from "features/model/service/test/getTests";
import {resetCorrectTestCount} from "features/model/slice/test/correct-test/correctTestSlice";
import {selectPagination} from "features/model/slice/test/testSlice";


export const MyTabs = () => {
    const dispatch = useAppDispatch();
    const testState = useAppSelector((state) => state.test);
    const pagination = useAppSelector(selectPagination);
    const { isLoading, tests } = testState;
    const { pageCount } = pagination;
    const [currentPage, setCurrentPage] = useState<number>(0);
    const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('');



    useEffect(() => {
        const params = {
            search: debouncedSearchQuery,
            my_tests: 1,
            page: currentPage,
        };
        dispatch(getTests(params));
    }, [debouncedSearchQuery, dispatch]);

    useEffect(() => {
        if (debouncedSearchQuery.trim() !== '') {
            const params = {
                search: debouncedSearchQuery,
            };
            dispatch(getTests(params));
        }
    }, [debouncedSearchQuery, dispatch]);

    const handleSearchInputChange = useSearchInputChangeHandler(setDebouncedSearchQuery);

    const onChangeHandle = (event: React.ChangeEvent<unknown>, value: number) => {
        setCurrentPage(value);
        dispatch(getTests({
            search: debouncedSearchQuery,
            my_tests: 1,
            page: value - 1
        }));
    };

    return (
        <div className="tabs-content">
            <div className="tab">
                {/* Search */}
                <MyTestSearch
                    onSearchInputChange={handleSearchInputChange}
                />

                <div className="data-tbl tests-tbl">
                    <TestRowThead/>

                    {isLoading ? (
                        <Preloader/>
                    ) : tests.length > 0 ? (
                        tests
                            .filter((test) => test.title.toLowerCase().includes(debouncedSearchQuery.toLowerCase()))
                            .map((test) => (
                                <MyTestItems key={test.id} test={test}/>
                            ))
                    ) : (
                        <NothingYetMessage/>
                    )}

                </div>
            </div>

            {pageCount > 1 && (
                <CustomPagination pageCount={pageCount} onChangeHandle={onChangeHandle}/>
            )}
        </div>
    );
};
